import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { UserService } from '../../service/user.service';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';
import { IAppState } from '../../../core/store/store';
import { NgRedux } from '@angular-redux/store';

@Component({
  selector: 'app-change-password-card',
  styleUrls: ['./change-password-card.component.scss'],
  templateUrl: './change-password-card.component.html',
})
export class ChangePasswordCardComponent implements OnInit {
  public username = '';
  public passwordValue = '';
  public verifyValue = '';
  constructor(
    private userService: UserService,
    private messageSnack: UiMessageSnackService,
    private router: Router,
    private store: NgRedux<IAppState>,
  ) { }

  public ngOnInit() { 
    this.username = this.store.getState().userState.currentUser.displayname;
  }

    public changePasswordClicked(passwordClickedLoginForm: NgForm) {
        const { password, verify }: { password: string, verify: string } = passwordClickedLoginForm.value;        
        if (password !== verify) {
            this.messageSnack.logMessage('ERROR',
                {
                    uiMessage: 'Passwörter stimmen nicht überein!',
                    module: 'ChangePasswordCardComponent',
                }
            );
            this.passwordValue = '';
            this.verifyValue = '';
            return;
        }
        if (!password || !password.trim()) {
            this.messageSnack.logMessage('ERROR',
                {
                    uiMessage: 'Ungültige Passwortlänge',
                    module: 'ChangePasswordCardComponent',
                });
            return;
        }
        this.userService.changePassword(password).then((data) => {
            this.messageSnack.logMessage('SUCCESS',
                {
                    uiMessage: 'Passwort erfolgreich geändert',
                    module: 'ChangePasswordCardComponent',
                });
                this.router.navigate(['/signin']);
        }).catch((error) => {
            this.passwordValue = '';
            this.verifyValue = '';
            this.messageSnack.logMessage('ERROR',
                {
                    uiMessage: 'Passwort konnte nicht geändert werden',
                    module: 'ChangePasswordCardComponent',
                });
        });
    }

  public cancel() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/compv/change-password-card/change-password-card.component.ts